import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import styles from './tooltip.scss';

const Tooltip = ({ children, style, placement }) =>
  <div className={classNames(styles.container, { [styles[placement]]: placement })} style={style}>
    {children}
    <span className={styles.triangle}/>
  </div>;

Tooltip.propTypes = {
  children: PropTypes.node,
  style: PropTypes.object,
  placement: PropTypes.string,
};

export default Tooltip;



// WEBPACK FOOTER //
// ./app/components/tooltip/tooltip.js